export const BILLING_ROUTE = {
  TITLE: "Billing",
  KEY: "billing",
  BILLING_PATH: "billing/:id",
  ABSOLUTE_PATH: "/billing/",
};
